import styled from "styled-components";
import { type PositionProps, position } from "styled-system";
import * as Badge from "./Badge";
import { EcoTagType } from "../../types/CommonTypes";
import { theme } from "../v2/toyota/theme/toyotaTheme";

const Tag = styled.span<PositionProps>`
    display: inline-block;
    font-family: ${theme.fonts.regular};
    font-size: 1.2rem;
    text-transform: uppercase;
    white-space: nowrap;
    ${position};
`;

export const Eco = styled(Tag)`
    display: flex;
    flex-direction: column;
    align-items: center;
    column-gap: ${theme.space[1]}px;
    row-gap: ${theme.space[1]}px;
    width: 50px;
    height: 50px;
    font-style: italic;
    text-align: center;
    color: #8f9496;
    white-space: normal;
`;

export const Motorisation = styled(Tag)<{ type: EcoTagType }>`
    margin: -5px;
    padding: 0 5px;
    font-style: italic;
    color: ${({ type }) => (type === EcoTagType.FuelCell ? theme.colors.fuelCell : theme.colors.hybrid)};

    ${Badge.EcoBadge} + & {
        margin-top: ${theme.space[1]}px;
    }
`;

export const EcoHorizontal = styled(Tag)`
    display: flex;
    align-items: center;
    font-weight: 700;

    ${Motorisation} {
        margin: 0;
        font-style: normal;

        ${Badge.EcoBadge} + & {
            margin-top: 0;
        }
    }
`;

export const Outline = styled.span`
    display: inline-block;
    padding: 3px 11px;
    font-family: ${theme.fonts.base};
    font-size: 1.3rem;
    line-height: 2rem;
    color: ${theme.colors.grey5};
    border: 1px solid ${theme.colors.grey5};
    border-radius: 4px;
`;
